export default {
  methods: {
    OpenPremiumModal: function (title, description) {
      this.$store.state.modal.premium.open = true
      this.$store.state.modal.premium.title = title
      this.$store.state.modal.premium.description = description
    },
    OpenRateLimitModal: function () {
      this.$store.state.modal.rateLimited.open = true
    },
    CloseRateLimitModal: function () {
      this.$store.state.modal.rateLimited.open = false
    }
  }
}
